module.exports = __webpack_public_path__ + "static/media/info-grey.24ee48e9.svg";